export enum PMNDemande_Statut {
    EnCoursRedaction,
    Envoyee,
    EnCoursDeTraitement,
    Refusee,
    Acceptee
}

export function PMNDemande_Statut_ToText(input: PMNDemande_Statut) {
    switch (input) {
        case PMNDemande_Statut.EnCoursRedaction:
            return 'Rédaction'
        case PMNDemande_Statut.Envoyee:
            return 'Nouveau'
        case PMNDemande_Statut.EnCoursDeTraitement:
            return 'En cours'
        case PMNDemande_Statut.Refusee:
            return 'Refusé'
        case PMNDemande_Statut.Acceptee:
            return 'Accepté'
    }
}
